<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col lg="6" md="8" sm="12">
          <b-card no-body class="mx-4">
            <b-card-body class="p-4">
              <b-form @submit.prevent="handleSubmit">
              
              <h1>Welcome</h1>
              
              <p class="text-muted">Create your account</p>

              <b-alert variant="danger" dismissible :show="showDismissibleAlert" @dismissed="showDismissibleAlert=false">
                {{dismissibleMessage}}
              </b-alert>

              <b-input-group class="mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="icon-user"></i></span>
                </div>
                <b-form-input type="text" placeholder="Name" id="name" v-model="name" v-bind:class="[(errors.name)? 'is-invalid': '']"></b-form-input>                  
                <b-form-invalid-feedback v-for="item in errors.name" v-if="errors.name.length">
                  {{ item }}
                </b-form-invalid-feedback>
              </b-input-group>

              <b-input-group class="mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="icon-envelope"></i></span>
                </div>
                <b-form-input type="text" class="form-control" placeholder="Email" id="email" v-model="email" v-bind:class="[(errors.email)? 'is-invalid': '']"></b-form-input>
                <b-form-invalid-feedback v-for="item in errors.email" v-if="errors.email.length">
                  {{ item }}
                </b-form-invalid-feedback>
              </b-input-group>

              <b-input-group class="mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="icon-lock"></i></span>
                </div>
                <b-form-input type="password" class="form-control" placeholder="Password" id="password" v-model="password" v-bind:class="[(errors.password)? 'is-invalid': '']"></b-form-input>
                <b-form-invalid-feedback v-for="item in errors.password" v-if="errors.password.length">
                  {{ item }}
                </b-form-invalid-feedback>
              </b-input-group>

              <b-input-group class="mb-4">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="icon-lock"></i></span>
                </div>
                <b-form-input type="password" class="form-control" placeholder="Repeat password" id="password_confirmation" v-model="password_confirmation" v-bind:class="[(errors.password_confirmation)? 'is-invalid': '']"></b-form-input>
                <b-form-invalid-feedback v-for="item in errors.password_confirmation" v-if="errors.password_confirmation.length">
                  {{ item }}
                </b-form-invalid-feedback>
              </b-input-group>

              <p class="text-muted">By signing up, I agree to SiteName's terms of service, privacy policy, and community guidelines.</p>

              <b-button variant="primary" type="submit" v-bind:disabled="!isValid" block>Create Account</b-button>
              </b-form>
            </b-card-body>
            <b-card-footer class="p-4">
              <b-row>
                <b-col cols="12" class="text-center text-muted">
                  Already have an account? <b-button variant="link" class="px-0" href="#/pages/signin">Sign in</b-button>
                </b-col>                
              </b-row>              
            </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'register',
    data: function () {
      return {
        apiHost: window.apiHost,
        apiUri: window.apiUri,
        showDismissibleAlert: false,
        dismissibleMessage: '',
        errors: {},
        name: '',
        email: '',
        password: '',
        password_confirmation: ''
      }
    },
    computed: {
      isValid: function () {
        return this.name !== '' && this.email !== '' && this.password !== '' && this.password_confirmation !== ''
      }
    },
    methods: {
      handleSubmit: function () {
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
        axios.defaults.headers.common['Accept'] = 'application/json'
        this.showDismissibleAlert = false
        this.dismissibleMessage = ''
        this.errors = {}

        let uri = this.apiUri + 'register'
        axios.post(uri,
          {
            'name': this.name,
            'email': this.email,
            'password': this.password,
            'password_confirmation': this.password_confirmation
          })
          .then(response => {
            console.log(response)
            this.$router.push('/pages/signin')
          })
          .catch(error => {
            // Wu oh! Something went wrong
            let response = error.response.data
            console.log(response)
            if (typeof (response.message) !== 'undefined') {
              this.showDismissibleAlert = true
              this.dismissibleMessage = response.message
            }
            if (typeof (response.errors) !== 'undefined') {
              this.errors = response.errors
            }
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Register.vue